<template>
  <section class="page user-profile">
    <card-box
      title="我的书架"
      :iconSrc="resourceIcon"
      class="resource-info-box"
      showGap
    >
      <div class="header-tabs">
        <el-tabs
          v-model="activeBookshelfTab"
          @tab-click="switchBookshelfTab"
          :class="'tab-wrap-' + currentBookshelfTabIndex"
        >
          <el-tab-pane label="我的商品" name="my-goods">
            <div class="myResources2">
              <div
                class="myResources2_li"
                v-for="(item, index) in bookshelfModel[0].dataList"
                :key="index"
              >
                <div class="myResources2_liimgbox">
                  <el-image
                    class="myResources2_liimg"
                    @click="toread(item)"
                    :src="item.cover"
                  ></el-image>
                  <span class="scll" v-show="item.isRead === '0'"
                    >上次浏览</span
                  >
                  <img
                    v-show="
                      item.isBuy === '0' && item.acquireSource != 'lexueCode'
                    "
                    class="ygm"
                    src="@/assets/icon/ygm_ico.png"
                  />
                </div>
                <div class="myResources2_b" @click="toread(item)">
                  <span v-show="item.sourceFile">{{ item.sourceFile }}</span>
                  <p class="ellipsis-aRow" :title="item.relevanceName">
                    {{ item.relevanceName }}
                  </p>
                </div>
              </div>
              <no-data v-show="bookshelfModel[0].total === 0"></no-data>
            </div>
          </el-tab-pane>
          <el-tab-pane label="我的专题" name="my-subject">
            <div class="demo-card-list">
              <div
                class="demo-commodit-card"
                v-for="(item, index) in bookshelfModel[1].dataList"
                :key="index"
              >
                <div
                  class="demo-card-imgbox flex-center"
                  @click="tomyDetail(item)"
                >
                  <img :src="item.cover" />
                </div>
                <div class="demo-card-body-box">
                  <div class="title ellipsis-aRow" @click="tomyDetail(item)">
                    {{ item.relevanceName }}
                  </div>
                  <div class="demo-card-info">
                    <div class="resource ellipsis-aRow">
                      共{{ item.resourceNum }}个资源
                    </div>
                    <div v-if="item.isBuy === '0'" style="font-size: 14px">
                      <img
                        v-show="item.isBuy === '0'"
                        class="ygm"
                        src="@/assets/icon/ygm_ico.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <no-data v-show="bookshelfModel[1].total === 0"></no-data>
          </el-tab-pane>
          <el-tab-pane label="我的资源包" name="my-bundle">
            <div class="demo-card-list">
              <div
                class="demo-commodit-card"
                v-for="(item, index) in bookshelfModel[2].dataList"
                :key="index"
              >
                <div
                  class="demo-card-imgbox flex-center"
                  @click="tozybDetail(item)"
                >
                  <img :src="item.cover" />
                </div>
                <div class="demo-card-body-box">
                  <div class="title ellipsis-aRow" @click="tozybDetail(item)">
                    {{ item.relevanceName }}
                  </div>
                  <div class="demo-card-info">
                    <div class="resource ellipsis-aRow">
                      共{{ item.resourceNum }}个资源
                    </div>
                    <div v-if="item.isBuy === '0'" style="font-size: 14px">
                      <img
                        v-show="item.isBuy === '0'"
                        class="ygm"
                        src="@/assets/icon/ygm_ico.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <no-data v-show="bookshelfModel[2].total === 0"></no-data>
          </el-tab-pane>
          <el-tab-pane label="我的题库" name="my-resources">
            <div style="margin-top: 10px"></div>
            <div class="myResources2">
              <div
                class="myResources2_li"
                v-for="(item, index) in paperGoods.slice(0, 10)"
                :key="index"
              >
                <div class="myResources2_liimgbox">
                  <el-image
                    class="myResources2_liimg"
                    @click="toread(item)"
                    :src="item.cover"
                  ></el-image>
                  <span class="scll" v-show="item.isRead === '0'"
                    >上次浏览</span
                  >
                  <img
                    v-show="
                      item.isBuy === '0' && item.acquireSource != 'lexueCode'
                    "
                    class="ygm"
                    src="@/assets/icon/ygm_ico.png"
                  />
                </div>
                <div class="myResources2_b" @click="toread(item)">
                  <span v-show="item.sourceFile">{{ item.sourceFile }}</span>
                  <p class="ellipsis-aRow" :title="item.relevanceName">
                    {{ item.relevanceName }}
                  </p>
                </div>
              </div>
              <no-data v-show="bookshelfModel[0].total === 0"></no-data>
            </div>
            <no-data v-show="total4 == 0"></no-data>
          </el-tab-pane>
        </el-tabs>
      </div>
    </card-box>
    <card-box title="学习记录" :iconSrc="orderIcon" class="order-info-box">
      <div class="learn_box">
        <div class="left_box">
          <div class="left_top" @click="toReaderTime">
            <img src="@/assets/images/times.png" alt="" />
            <div class="lefttop_right">
              <div>
                今日学习<span class="bluetext">{{
                  toHours(learningRecord.timeByTheDay)
                }}</span
                >小时<span class="bluetext">{{
                  toMinutes(learningRecord.timeByTheDay)
                }}</span
                >分钟
              </div>
              <div class="seconed">
                共学习<span class="bluetext">{{ learningRecord.hour }}</span
                >小时<span class="bluetext">{{ learningRecord.minute }}</span
                >分钟
              </div>
            </div>
          </div>
          <div class="left_bottom" @click="tolearndetail">
            <div class="img_box">
              <img src="@/assets/images/boshimao.png" alt="" />
            </div>
            <div class="bottom_right">
              <div class="right_top">
                <span>学过</span>
                <span class="puper_text">{{ learningRecord.studyNum }}</span>
              </div>
              <div class="right_bottom">
                已阅读完{{ learningRecord.bookNum }}本书
              </div>
            </div>
          </div>
        </div>
        <div class="bookmart_box" @click="toMyNoteDetail('bookmark')">
          <div class="bookmart">
            <div class="bookmart_top">
              <span>书签</span
              ><span class="special">{{ learningRecord.bookmark.num }}</span>
            </div>
            <div class="bookmart_bottom">
              在{{ learningRecord.bookmark.bookNum }}本书上
            </div>
          </div>
        </div>
        <div class="bookmart_box note" @click="toMyNoteDetail('note')">
          <div class="bookmart">
            <div class="bookmart_top">
              <span>笔记</span
              ><span class="special">{{ learningRecord.note.num }} </span>
            </div>
            <div class="bookmart_bottom">
              在{{ learningRecord.note.bookNum }}本书上
            </div>
          </div>
        </div>
        <div class="bookmart_box line" @click="toMyNoteDetail('lineation')">
          <div class="bookmart">
            <div class="bookmart_top">
              <span>划线</span
              ><span class="special">{{ learningRecord.scribe.num }} </span>
            </div>
            <div class="bookmart_bottom">
              在{{ learningRecord.scribe.bookNum }}本书上
            </div>
          </div>
        </div>
      </div>
      <div class="card-gap"></div>
    </card-box>
    <card-box title="订单信息" :iconSrc="orderIcon" class="order-info-box">
      <div class="header-tabs">
        <el-tabs
          stretch
          v-model="activeTab"
          :class="'tab-wrap-' + currentTabIndex"
          @tab-click="switchTab"
        >
          <el-tab-pane
            :label="` 待付款 ( ${tabModels[0].total} )`"
            name="待付款"
          >
            <div class="list-wrap">
              <order-table :orderList="tabModels[0].dataList"></order-table>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="` 待评价 ( ${tabModels[1].total} )`"
            name="待评价"
          >
            <div class="list-wrap">
              <order-table :orderList="tabModels[1].dataList"></order-table>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="` 已完成 ( ${tabModels[2].total} )`"
            name="已完成"
          >
            <div class="list-wrap">
              <order-table :orderList="tabModels[2].dataList"></order-table>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="` 已取消 ( ${tabModels[3].total} )`"
            name="已取消"
          >
            <div class="list-wrap">
              <order-table :orderList="tabModels[3].dataList"></order-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </card-box>
    <el-dialog
      key="__index__"
      title="付款"
      :visible.sync="modalShow"
      width="500px"
      append-to-body
      :destroy-on-close="true"
      class="ou-modal pay-modal"
      @close="closed"
    >
      <div class="pay-modal-wrap">
        <div class="info-row">
          支付金额：<span class="price-span">{{
            (payDetail.payment || 0) | paymentText
          }}</span>
        </div>
        <div class="info-row">支付方式：</div>
        <div class="pay-way-wrap">
          <div
            class="pay-box"
            @click="selectWay('wx')"
            :class="[selectedWay === 'wx' ? 'active' : '']"
          >
            <div class="box-wrap">
              <el-image
                :src="require('@/assets/icon/wxpay.png')"
                fit="contain"
              ></el-image>
            </div>
            <el-image
              v-show="selectedWay === 'wx'"
              class="select-flag"
              :src="require('@/assets/icon/btn-pay-corner.png')"
              fit="contain"
            ></el-image>
          </div>
          <div
            class="pay-box"
            @click="selectWay('ali')"
            :class="[selectedWay === 'ali' ? 'active' : '']"
          >
            <div class="box-wrap">
              <el-image
                :src="require('@/assets/icon/alipay.png')"
                fit="contain"
              ></el-image>
            </div>
            <el-image
              v-show="selectedWay === 'ali'"
              class="select-flag"
              :src="require('@/assets/icon/btn-pay-corner.png')"
              fit="contain"
            ></el-image>
          </div>
        </div>
        <div v-show="selectedWay !== ''">
          <div class="info-row">扫码支付：</div>
          <div class="qrcode-box">
            <div id="qrcode2-index" v-show="selectedWay === 'wx'"></div>
            <div id="qrcode-index" v-show="selectedWay === 'ali'"></div>
            <div class="qrcode-tips">
              {{
                selectedWay === "wx"
                  ? "打开手机微信扫码支付"
                  : "打开手机支付宝扫码支付"
              }}
            </div>
            <div
              v-show="selectedWay === 'wx'"
              @click="refresh"
              class="qrcode-tips"
            >
              刷新
            </div>
            <div
              v-show="selectedWay === 'ali'"
              @click="refresh2"
              class="qrcode-tips"
            >
              刷新
            </div>
          </div>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mockPay">一键支付</el-button>
      </div> -->
    </el-dialog>
  </section>
</template>

<script>
import QRCode from "qrcodejs2";
import { aliCode, wxCode, aliOrderQuery, wxOrderQuery } from "@/api/cart/cart";
import { mapGetters, mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
import {
  apiGetUserOrderList,
  apiGetTotalGroup,
  apiAfterPay,
  getLearningRecord,
} from "@/api/user/order";
import {
  selectMyResourceListGoods,
  selectMyResourceListSubject,
  selectMyResourceListBundle,
} from "@/api/user/myResources.js";
import NoData from "@/components/noData.vue";
import CardBox from "./components/CardBox";
import OrderTable from "./components/OrderTable";
import { setToken } from "@/utils/auth";
import resourceIcon from "@/assets/icon/icon-user-index-resource.png";
import orderIcon from "@/assets/icon/icon-user-index-order.png";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";
export default {
  name: "userProfile",
  components: { CardBox, OrderTable, NoData },
  data() {
    return {
      learningRecord: {},
      listquery4: {
        pageNum: 1,
        pageSize: 10,
        resourceType: "bank",
        goodsType: "试卷",
      },
      paperGoods: [],
      total4: 0,
      orderNumber: null,
      codeUrl: null,
      codeUrl2: null,
      timer1: null,
      timer2: null,
      resourceIcon,
      orderIcon,
      listquery: {
        pageNum: 1,
        pageSize: 5,
        timeBar: null,
        buyStatus: null,
        goodsType: null,
        acquireSource: null,
      },
      prevTabIndex: 0,
      activeTab: "待付款",
      tabModels: [
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 2,
          },
          status: 0,
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 2,
          },
          status: 1,
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 2,
          },
          status: 3,
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            keyword: "",
            pageNum: 1,
            pageSize: 2,
          },
          status: 2,
          total: 0,
          dataList: [],
        },
      ],
      modalShow: false,
      selectedWay: "wx",
      payDetail: {},

      // 2022-08-09需求变更：我的书架添加tabs页
      activeBookshelfTab: "my-goods",
      bookshelfModel: [
        {
          searchParams: {
            pageNum: 1,
            pageSize: 5,
          },
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            pageNum: 1,
            pageSize: 3,
          },
          total: 0,
          dataList: [],
        },
        {
          searchParams: {
            pageNum: 1,
            pageSize: 3,
          },
          total: 0,
          dataList: [],
        },
      ],
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userId"]),
    currentTabIndex() {
      switch (this.activeTab) {
        case "待付款":
          return 0;
        case "待评价":
          return 1;
        case "已完成":
          return 2;
        case "已取消":
          return 3;
      }
    },
    currentBookshelfTabIndex() {
      switch (this.activeBookshelfTab) {
        case "my-goods":
          return 0;
        case "my-subject":
          return 1;
        case "my-bundle":
          return 2;
        case "my-resources":
          return 3;
      }
    },
  },
  provide() {
    return {
      refreshList: this.getCurrentTabOrderList,
      callPay: this.handlePay,
    };
  },
  filters: {
    paymentText(value) {
      let text = " - ";
      if (value || value === 0) {
        text = Number(value).toFixed(2);
      }
      return text;
    },
  },

  mounted() {
    this.getlearnlistfn();
  },
  activated() {
    this.getMyResourceList();
    this.getCurrentTabOrderList();
    this.getStatusTotal();
    this.getList4();
  },
  beforeDestroy() {
    this.timer1 && clearInterval(this.timer1);
    this.timer2 && clearInterval(this.timer2);
  },
  methods: {
    toread(item) {
      if (item.goodsType == "train") {
        let url = this.$router.resolve({
          path: "/willingLearn/courseQuestions",
          query: {
            goodsId: item.relevanceId,
          },
        });
        window.open(url.href, "_blank");
      } else if (item.goodsType == "paper") {
        //判断题组类型
        goodsInfoDetail(item.relevanceId).then((res) => {
          if (res.code == 200) {
            if (res.data.sourceList.length > 0) {
              if (res.data.sourceList[0].resourceType == "bank") {
                let url = this.$router.resolve({
                  path: "/bookstore/bookstoreDetail",
                  query: {
                    goodsId: item.relevanceId,
                    goodsType: item.goodsType,
                  },
                });
                window.open(url.href, "_blank");
              } else {
                let url = this.$router.resolve({
                  path: "/bookstore/answer",
                  query: {
                    goodsId: item.relevanceId,
                    relevanceId: item.relevanceId, //业务id
                    resource: item.acquireSource, //来源
                    resourceType: item.resourceType,
                    teachInstId: item.teachInstId,
                    fromType: "/user/myResources",
                  },
                });
                window.open(url.href, "_blank");
              }
            }
          }
        });
      } else {
        let url = this.$router.resolve({
          path: "/onlineReading",
          query: {
            goodsId: item.relevanceId,
            relevanceId: item.relevanceId, //业务id
            resource: item.acquireSource, //来源
            resourceType: item.resourceType,
            typeName: item.isBuy || "", //判断是否能加入书架
            teachInstId: item.teachInstId,
          },
        });
        window.open(url.href, "_blank");
      }
    },
    getList4() {
      selectMyResourceListGoods(this.listquery4).then((res) => {
        this.paperGoods = res.rows;
        this.total4 = res.total;
      });
    },
    getMyResourceList() {
      selectMyResourceListGoods(this.bookshelfModel[0].searchParams).then(
        (res) => {
          this.bookshelfModel[0].total = res.total || 0;
          this.bookshelfModel[0].dataList = res.rows;
        }
      );
    },
    getMySubjectList() {
      selectMyResourceListSubject(this.bookshelfModel[1].searchParams).then(
        (res) => {
          this.bookshelfModel[1].total = res.total || 0;
          this.bookshelfModel[1].dataList = res.rows;
        }
      );
    },
    getMyBundleList() {
      selectMyResourceListBundle(this.bookshelfModel[2].searchParams).then(
        (res) => {
          this.bookshelfModel[2].total = res.total || 0;
          this.bookshelfModel[2].dataList = res.rows;
        }
      );
    },
    handlePay(detail) {
      this.payDetail = detail;
      this.modalShow = true;
      this.orderNumber = this.payDetail.orderNumber;
      this.selectedWay === "wx" && this.getWxCode();
      this.selectedWay === "ali" && this.getAliCode();
      this.selectedWay === "wx" && this.wxOrderState();
      this.selectedWay === "ali" && this.aliOrderState();
    },
    // 点击一键支付
    mockPay() {
      // TODO:
      apiAfterPay({ id: this.payDetail.id }).then(() => {
        this.modalShow = false;
        this.$message.success("订单支付成功");
        this.timer1 && clearInterval(this.timer1);
        this.timer2 && clearInterval(this.timer2);
        setTimeout(() => {
          this.getCurrentTabOrderList();
        }, 500);
      });
    },
    selectWay(value) {
      if (value === "wx") {
        this.selectedWay = "wx";
        this.getWxCode();
        clearInterval(this.timer2);
        clearInterval(this.timer1);
        this.wxOrderState();
      } else if (value === "ali") {
        this.selectedWay = "ali";
        this.getAliCode();
        clearInterval(this.timer1);
        clearInterval(this.timer2);
        this.aliOrderState();
      }
    },
    getWxCode() {
      // 获取微信二维码
      wxCode(this.orderNumber).then((res) => {
        let code = res.data ? res.data.qrCode : null;
        if (!code) {
          this.$message.error("获取支付二维码失败");
          const dom = document.getElementById("qrcode2-index");
          if (dom) dom.innerHTML = "";
          return;
        }
        this.codeUrl2 = code;
        this.$nextTick(() => {
          this.createQrcode2();
        });
      });
    },
    getAliCode() {
      // 获取支付宝二维码
      aliCode(this.orderNumber).then((res) => {
        let code = res.data ? res.data.qrCode : null;
        if (!code) {
          this.$message.error("获取支付二维码失败");
          const dom = document.getElementById("qrcode-index");
          if (dom) dom.innerHTML = "";
          return;
        }
        this.codeUrl = code;
        this.$nextTick(() => {
          this.createQrcode();
        });
      });
    },
    createQrcode() {
      // 若存在，先删除二维码
      const dom = document.getElementById("qrcode-index");
      if (dom) dom.innerHTML = "";
      // 这里会自动去取模版中的id为qrcode的
      console.log("alidom", dom, this.codeUrl);
      const qrcode = new QRCode("qrcode-index", {
        width: 150, // 宽
        height: 150, // 高
        text: this.codeUrl, // 链接地址
      });
      return qrcode;
    },
    createQrcode2() {
      // 若存在，先删除二维码
      const dom = document.getElementById("qrcode2-index");
      if (dom) dom.innerHTML = "";
      // 这里会自动去取模版中的id为qrcode的
      console.log("wxdom", dom, this.codeUrl2);
      const qrcode = new QRCode("qrcode2-index", {
        width: 150, // 宽
        height: 150, // 高
        text: this.codeUrl2, // 链接地址
      });
      return qrcode;
    },
    switchTab(e, v) {
      // console.log("切换,", e, v);
      // console.log("当前激活页及页码", this.activeTab, this.currentTabIndex);
      this.tabModels[this.prevTabIndex].searchParams.keyword = "";
      this.prevTabIndex = this.currentTabIndex;
      this.getCurrentTabOrderList();
    },
    getCurrentTabOrderList() {
      let model = this.tabModels[this.currentTabIndex];
      let {
        searchParams: { pageNum, pageSize, keyword },
        status,
      } = model;
      let params = { status, pageSize, pageNum, userId: this.userId };
      params = keyword ? { ...params, keyword } : params;
      // console.log("订单列表参数：", params);
      apiGetUserOrderList(params).then((res) => {
        // console.log("订单列表返回：", res);
        let list = res.rows || [],
          total = res.total || 0;
        this.tabModels[this.currentTabIndex].dataList = list;
        this.tabModels[this.currentTabIndex].total = total;
      });
    },
    getStatusTotal() {
      apiGetTotalGroup({ userId: this.userId }).then((res) => {
        let { allCount, waitPayCount, talkCount, closeCount, finishCount } =
          res;
        this.tabModels[0].total = Number(waitPayCount);
        this.tabModels[1].total = Number(talkCount);
        this.tabModels[2].total = Number(finishCount);
        this.tabModels[3].total = Number(closeCount);
      });
    },
    //刷新二维码
    refresh() {
      $(".qrcode").html(""); //把之前的置为空
      this.getWxCode();
    },
    //刷新二维码
    refresh2() {
      $(".qrcode").html(""); //把之前的置为空
      this.getAliCode();
    },
    // 轮询微信订单状态
    wxOrderState() {
      this.timer1 = setInterval(() => {
        wxOrderQuery(this.orderNumber, "web").then((res) => {
          if (res.code == 200) {
            clearInterval(this.timer1);
            this.modalShow = false;
            this.$message.success("订单支付成功");
            setTimeout(() => {
              this.getCurrentTabOrderList();
              this.getStatusTotal();
              this.currentBookshelfTabIndex === 0 && this.getMyResourceList();
              this.currentBookshelfTabIndex === 1 && this.getMySubjectList();
              this.currentBookshelfTabIndex === 2 && this.getMyBundleList();
              this.currentBookshelfTabIndex === 3 && this.getList4();
            }, 800);
          }
        });
      }, 3000);
    },
    // 轮询支付宝订单状态
    aliOrderState() {
      this.timer2 = setInterval(() => {
        aliOrderQuery(this.orderNumber).then((res) => {
          if (res.code == 200) {
            clearInterval(this.timer2);
            this.modalShow = false;
            this.$message.success("订单支付成功");
            setTimeout(() => {
              this.getCurrentTabOrderList();
              this.getStatusTotal();
              this.currentBookshelfTabIndex === 0 && this.getMyResourceList();
              this.currentBookshelfTabIndex === 1 && this.getMySubjectList();
              this.currentBookshelfTabIndex === 2 && this.getMyBundleList();
              this.currentBookshelfTabIndex === 3 && this.getList4();
            }, 800);
          }
        });
      }, 3000);
    },
    //当点击弹出框的关闭时
    closed() {
      this.timer1 && clearInterval(this.timer1);
      this.timer2 && clearInterval(this.timer2);
    },
    switchBookshelfTab(e, v) {
      e.index === "0" && this.getMyResourceList();
      e.index === "1" && this.getMySubjectList();
      e.index === "2" && this.getMyBundleList();
      e.index === "3" && this.getList4();
    },
    tomyDetail(item) {
      this.$router.push({
        path: "/special/myspecialDetail",
        query: {
          subjectId: item.id,
          resourceType: item.resourceType,
          resource: item.acquireSource,
          relevanceId: item.relevanceId, //业务id
        },
      });
    },
    tozybDetail(item) {
      this.$router.push({
        path: "/user/myresourcesDetail",
        query: {
          subjectId: item.id,
          resourceType: item.resourceType,
          resource: item.acquireSource,
          relevanceId: item.relevanceId, //业务id
          teachInstId: item.teachInstId,
        },
      });
    },
    getlearnlistfn() {
      getLearningRecord().then((res) => {
        this.learningRecord = res.data || {};
        console.log(res);
      });
    },
    //分钟数转时分
    toHours(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return hours;
    },
    toMinutes(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return minutes;
    },
    toReaderTime() {
      this.$router.push({ path: "/user/readerTime" });
    },
    toMyNoteDetail(type) {
      this.$router.push({
        path: "/user/mynote",
        query: { type: type },
      });
    },
    tolearndetail() {
      this.$router.push({
        path: "/user/learningRecord",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.resource-info-box ::v-deep {
  .header-tabs {
    position: relative;
    .el-tabs__header {
      margin-bottom: 14px;
    }
    .el-tabs__nav-wrap {
      padding: 0 15px;
      height: 52px;
      border-bottom: 1px solid #f2f2f2;
    }
    .el-tabs__item {
      height: 52px;
      line-height: 52px;
      padding: 0 27px;
      &:last-child {
        padding-right: 0;
      }
      &.is-active {
        color: #2e9adb;
      }
    }
    .el-tabs__active-bar {
      background-color: #2e9adb;
      width: 90px !important;
    }
    .tab-wrap-0 {
      .el-tabs__active-bar {
        transform: translateX(10px) !important;
      }
    }
    .tab-wrap-1 {
      .el-tabs__active-bar {
        transform: translateX(119px) !important;
      }
    }
    .tab-wrap-2 {
      .el-tabs__active-bar {
        transform: translateX(237px) !important;
      }
    }
  }
  .myResources2 {
    width: 100%;
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
    // box-sizing: border-box;
  }

  .myResources2 i {
    display: none;
  }

  .myResources2_li {
    width: 150px;
    // float: left;
    margin-right: 68px;
    margin-bottom: 20px;
  }

  .myResources2_li:nth-child(5n) {
    margin-right: 0;
  }

  .myResources2_liimgbox {
    width: 150px;
    height: 150px;
    // float: left;
    position: relative;
    margin-bottom: 15px;
  }

  .myResources2_liimg {
    cursor: pointer;
    width: 150px;
    height: 150px;
    border-radius: 6px;
    border: 1px solid #f2f2f2;
    background: #fff;
  }

  .myResources2_b {
    cursor: pointer;
    width: 100%;
    // float: left;
  }

  .myResources2_b span {
    float: left;
    margin-right: 7px;
    padding: 0 10px;
    height: 24px;
    background: #f9fdff;
    border: 1px solid #0081ce;
    border-radius: 6px;
    font-size: 13px;
    line-height: 24px;
    text-align: center;
    font-family: PingFang SC;
    font-weight: 400;
    color: #0081ce;
  }

  .myResources2_b p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }
  .myResources2_b p:hover {
    color: #1690ff;
    text-decoration: underline;
  }

  .scll {
    position: absolute;
    left: 2px;
    top: 7px;
    width: 54px;
    height: 24px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0px 12px 12px 0px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
  }

  .ygm {
    position: absolute;
    right: 10px;
    bottom: 10px;
    pointer-events: none;
  }

  .myResources2_li_close {
    position: absolute;
    right: -2px;
    top: 0;
    cursor: pointer;
    font-size: 20px;
  }

  .demo-card-list {
    padding: 0 40px 12px;
    box-sizing: border-box;
    display: grid;
    width: 100%;
    grid-row-gap: 30px;
    -webkit-column-gap: 20px;
    -moz-column-gap: 20px;
    column-gap: 20px;
    grid-template-columns: repeat(auto-fit, 320px);
  }

  .demo-card-list .demo-commodit-card {
    position: relative;
    width: 320px;
    height: 340px;
    background: #ffffff;
    // -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    // box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .demo-card-list .demo-commodit-card .demo-card-imgbox {
    width: 320px;
    height: 240px;
    cursor: pointer;
  }

  .demo-card-list .demo-commodit-card .demo-card-imgbox img {
    // max-width: 100%;
    // max-height: 100%;
    // object-fit: scale-down;
    width: 100%;
    height: 100%;
  }

  .demo-card-list .demo-commodit-card .demo-card-body-box {
    padding: 11px 10px 17px 14px;
  }

  .demo-card-list .demo-commodit-card .demo-card-body-box .title {
    margin-bottom: 12px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    width: 280px;
    cursor: pointer;
  }
  .demo-card-list .demo-commodit-card .demo-card-body-box .title:hover {
    color: #1690ff;
    text-decoration: underline;
  }
  .demo-card-list .demo-commodit-card .demo-card-body-box .demo-card-info {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .demo-card-list
    .demo-commodit-card
    .demo-card-body-box
    .demo-card-info
    .resource {
    max-width: 155px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 5px;
    min-width: 100px;
    height: 28px;
    background: #ffffff;
    border: 1px solid #0081ce;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #0081ce;
    text-align: center;
    line-height: 28px;
  }

  .demo-card-list
    .demo-commodit-card
    .demo-card-body-box
    .demo-card-info
    .price {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ff5353;
  }

  .demo-card-list
    .demo-commodit-card
    .demo-card-body-box
    .demo-card-info
    .price
    .yprice {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    text-decoration: line-through;
    color: #999999;
  }
}

.order-info-box ::v-deep {
  .header-tabs {
    position: relative;
    .el-tabs__header {
      margin-bottom: 12px;
    }
    .el-tabs__nav-wrap {
      padding: 0 30px;
      height: 52px;
      border-bottom: 1px solid #f2f2f2;
    }
    .el-tabs__item {
      height: 52px;
      line-height: 52px;
      padding: 0 27px;
      &:nth-child(2) {
        padding-left: 10px;
      }
      &:last-child {
        padding-right: 0;
      }
      &.is-active {
        color: #2e9adb;
      }
    }
    .el-tabs__active-bar {
      background-color: #2e9adb;
      width: 90px !important;
    }
    .tab-wrap-0 {
      .el-tabs__active-bar {
        transform: translateX(71px) !important;
      }
    }
    .tab-wrap-1 {
      .el-tabs__active-bar {
        transform: translateX(336px) !important;
      }
    }
    .tab-wrap-2 {
      .el-tabs__active-bar {
        transform: translateX(604px) !important;
      }
    }
    .tab-wrap-3 {
      .el-tabs__active-bar {
        transform: translateX(870px) !important;
      }
    }
  }
  .list-wrap {
    padding: 0 20px;
  }
  .pagination-box {
    padding: 24px 30px;
    text-align: right;
  }
}

.ou-modal.pay-modal ::v-deep {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.pay-modal-wrap {
  .info-row {
    display: flex;
    align-items: center;
    padding: 8px;
  }
}

.price-span {
  font-size: 18px;
  font-weight: 400;
  color: #ff5353;
  margin-left: 16px;
  &::before {
    content: "¥";
  }
}

.pay-way-wrap {
  padding: 28px 20px 34px;
  display: flex;
  justify-content: space-between;
  .pay-box {
    width: 180px;
    height: 56px;
    position: relative;
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
    cursor: pointer;
    .box-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.active {
      border: 1px solid #2e9adb;
    }
    .select-flag {
      position: absolute;
      bottom: -1px;
      right: 0;
    }
  }
}

.qrcode-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 20px 48px;
  flex-direction: column;
  .qrcode-img {
    width: 150px;
    height: 150px;
  }
  .qrcode-tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin-top: 20px;
    cursor: pointer;
  }
  .qrcode-tips:last-of-type {
    cursor: pointer;
  }
}

.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 200px;
    font-size: 16px;
    padding: 8px 20px;
    background-color: #2e9adb;
    border-radius: 6px;
  }
}
.learn_box {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px 28px 55px;
  .left_box {
    height: 198px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .left_top {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 250px;
      background-image: url("../../../assets/images/qingmask.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 93px;
      img {
        margin-left: 21px;
        width: 36px;
        height: 36px;
      }
      .lefttop_right {
        margin-left: 16px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #010101;
        .bluetext {
          font-size: 16px;
          font-weight: 700;
          color: #068da1;
        }
        .one_item {
          cursor: pointer;
        }
        .seconed {
          margin-top: 19px;
        }
      }
    }
    .left_bottom {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 250px;
      background-image: url("../../../assets/images/pupermask.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 93px;
      .img_box {
        margin-left: 21px;
        width: 43px;
        height: 32px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bottom_right {
        margin-left: 25px;
        .right_top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          .puper_text {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #504398;
          }
        }
        .right_bottom {
          margin-top: 18px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #7487b2;
        }
      }
    }
  }
  .bookmart_box {
    cursor: pointer;
    width: 194px;
    height: 198px;
    background-image: url("../../../assets/images/orangemask.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 49px;
    padding-left: 29px;
    box-sizing: border-box;
    .bookmart {
      border-left: 3px solid #dc8e22;
      padding-left: 16px;
      .bookmart_top {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFang SC;
        color: #333333;
        .special {
          margin-left: 45px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #cc7212;
        }
      }
      .bookmart_bottom {
        margin-top: 24px;
        font-size: 16px;
        font-family: PingFang SC;
        color: #815e19;
      }
    }
  }
  .note {
    background-image: url("../../../assets/images/greenmask.png");
    .bookmart {
      border-left: 3px solid #478b11;
    }
    .special {
      color: #478b11 !important;
    }
    .bookmart_bottom {
      color: #478b11 !important;
    }
  }
  .line {
    background-image: url("../../../assets/images/bluemask.png");
    .bookmart {
      border-left: 3px solid #2a67c8;
    }
    .special {
      color: #2a67c8 !important;
    }
    .bookmart_bottom {
      color: #0c4db4 !important;
    }
  }
}
</style>
<style scoped>
.demo-card-list .demo-commodit-card {
  -webkit-box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 10%);
  box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 10%);
}
</style>
